import { useAuditApi } from "./common/auditApi";

export function usePackagingAuditApi() {
  return useAuditApi({
    url: 'packaging',
    translateTitle: (t) => t.audit.actions.fetchPackaging.title,
    translateError: (t) => t.audit.actions.fetchPackaging.error
  });
}
